import { render } from "./TheImpersonateStop.vue?vue&type=template&id=0ea4fab0&scoped=true&ts=true"
import script from "./TheImpersonateStop.vue?vue&type=script&lang=ts"
export * from "./TheImpersonateStop.vue?vue&type=script&lang=ts"

import "./TheImpersonateStop.vue?vue&type=style&index=0&id=0ea4fab0&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea4fab0"]])

export default __exports__